"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteContentScopes = exports.HrefBehavior = void 0;
var HrefBehavior;
(function (HrefBehavior) {
    HrefBehavior["None"] = "none";
    HrefBehavior["Relative"] = "relative";
    HrefBehavior["External"] = "external";
    HrefBehavior["GameSlot"] = "game_slot";
    HrefBehavior["GameLiveCasino"] = "game_livecasino";
})(HrefBehavior || (exports.HrefBehavior = HrefBehavior = {}));
var SiteContentScopes;
(function (SiteContentScopes) {
    SiteContentScopes["Desktop"] = "desktop";
    SiteContentScopes["Mobile"] = "mobile";
    SiteContentScopes["Live"] = "live";
    SiteContentScopes["Prematch"] = "prematch";
    SiteContentScopes["Casino"] = "casino";
    SiteContentScopes["Bonuses"] = "bonuses";
    SiteContentScopes["Livecasino"] = "livecasino";
    SiteContentScopes["Slots"] = "slots";
    SiteContentScopes["MainBanner"] = "main_banner";
    SiteContentScopes["TopBanner"] = "top_banner";
    SiteContentScopes["BottomBanner"] = "bottom_banner";
    SiteContentScopes["Homepage"] = "homepage";
    SiteContentScopes["BonusReferral"] = "bonus_referral";
    SiteContentScopes["BonusCashback"] = "bonus_cashback";
    SiteContentScopes["BonusPromo2"] = "promo_2";
    SiteContentScopes["BonusPromo3"] = "promo_3";
    SiteContentScopes["BonusPromo4"] = "promo_4";
    SiteContentScopes["BonusPromo5"] = "promo_5";
    SiteContentScopes["BonusPromo6"] = "promo_6";
    SiteContentScopes["BonusPromoAviator"] = "promo_aviator";
    SiteContentScopes["BonusPromoCasino"] = "promo_casino";
    SiteContentScopes["BonusPromoCasino2"] = "promo_casino_2";
    SiteContentScopes["VFX"] = "vfx";
    SiteContentScopes["AllPages"] = "allpages";
})(SiteContentScopes || (exports.SiteContentScopes = SiteContentScopes = {}));
//# sourceMappingURL=banner.js.map